import { createFileRoute } from '@tanstack/react-router';
import { SearchLocationPage } from '../components/auth/SearchLocationPage';

export const Route = createFileRoute('/search-location')({
  component: SearchLocation,
});

function SearchLocation() {
  return <SearchLocationPage />;
}
